import React from 'react'
import { Layout } from 'antd'
import PropTypes from 'prop-types'

import { StyledPage, StyledPageContent } from '../styled'

import NavigationBar from './navigation-bar'

const Page = ({ children, renderRightMenu }) => (
  <Layout>
    <StyledPage>
      <NavigationBar renderRightMenu={renderRightMenu} />
      <StyledPageContent>
        <Layout.Content>{children}</Layout.Content>
      </StyledPageContent>
    </StyledPage>
  </Layout>
)

Page.propTypes = {
  children: PropTypes.node.isRequired,
  renderRightMenu: PropTypes.func,
}

Page.defaultProps = {
  renderRightMenu: undefined,
}

export default Page
